<footer id="rs-footer" class="rs-footer home9-style">
  <div class="footer-top">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12 footer-widget md-mb-40">
          <h3 class="widget-title footer-title">Get In Touch</h3>
          <ul class="address-widget footer-contact">
            <li>
              <div class="desc">
                <strong>Sri Balaji Educational Society (India)</strong><br>
                Anantapuramu - 515001<br>
                Andhra Pradesh, India
              </div>
            </li>
           
          </ul>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-12 footer-widget md-mb-40">
          <h3 class="widget-title footer-title">Popular Links</h3>
          <ul class="site-map footer-links">
            <li><a [routerLink]="['/about']">About Us</a></li>
            <li><a [routerLink]="['/contact']">Contact Us</a></li>
            <li><a [routerLink]="['/contact']">Our Services</a></li>
            <li><a [routerLink]="['/home']">Terms & Condition</a></li>

            <li><a [routerLink]="['/home']">Support</a></li>
          </ul>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 footer-widget md-mb-40">
          <h3 class="widget-title footer-title">Address</h3>
          <ul class="address-widget footer-contact">
            <li>
              <i class="flaticon-location"></i>
              <div class="desc">
                Near RTC Bus stand , Anantapuramu - 515001 . (AP)
              </div>
            </li>
            <li>
              <i class="flaticon-call"></i>
              <div class="desc">
                <a href="tel:+91 08554232268">08554 - 232268 / 243366</a>
              </div>
            </li>
            <li>
              <i class="flaticon-email"></i>
              <div class="desc">
                <a href="mailto:info@sbesatp.org">info@sbesatp.org</a>
              </div>
            </li>
          </ul>
        </div>
        </div>
      </div>
  </div>
  <div class="footer-bottom">
    <div class="container">
      <div class="row y-middle">
        <div class="col-lg-4 md-mb-20">
          <div class="footer-logo md-text-center">
            <a href="/">
              <img src="assets/college/sbesatp.png" alt="Sbes atp">
            </a>
          </div>
        </div>
        <div class="col-lg-4 md-mb-20">
          <div class="copyright text-center md-text-left">
            <p>All Right Reserved. Sri Balaji Educational Society , Anantapur © 2026</p>
          </div>
        </div>
        <div class="col-lg-4 text-right md-text-left">
          <ul class="footer-social">
            <li><a href="https://www.facebook.com/SbesAtp"><i class="fa fa-facebook"></i></a></li>
            <li><a href="#"><i class="fa fa-twitter"></i></a></li>
            <li><a href=""><i class="fa fa-instagram"></i></a></li>
            <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
            <li><a href="#"><i class="fa fa-pinterest-p"></i></a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>
